import { render } from "./ProductCosts.vue?vue&type=template&id=749bba15"
import script from "./ProductCosts.vue?vue&type=script&lang=js"
export * from "./ProductCosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__